export default __webpack_public_path__ + "static/media/percent.b448c0a5.svg";